import { useCallback } from 'react'
import { useFormContext } from 'react-hook-form'

import { CourtCasePaymentEventType } from '@app/graphql/types'

const BASE_PROCEDURAL_FEE_FACTOR = {
  [CourtCasePaymentEventType.FirstInstance]: 1.3,
  [CourtCasePaymentEventType.SecondInstance]: 1.6,
  [CourtCasePaymentEventType.ThirdInstance]: 2.3
}

export const useUpdateProceduralFeeFactor = () => {
  const { watch, setValue } = useFormContext()

  const updateProceduralFeeFactor = useCallback(() => {
    const instance = watch('Instance')
    const clientCount = watch('ClientCount')

    if (!instance || !clientCount) {
      return
    }

    const minimumFactor = BASE_PROCEDURAL_FEE_FACTOR[instance]
    const additionalFactor = (clientCount - 1) * 0.3

    const maximumFactor = minimumFactor + 2

    const factor = Math.min(minimumFactor + additionalFactor, maximumFactor)

    setValue('ProceduralFeeFactor', factor.toPrecision(2))
  }, [watch, setValue])

  return { updateProceduralFeeFactor }
}
